import React, { useState, useEffect } from "react";
import Layout from "../../Components/Layout/layout";
import dashboardclasses from "../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Services } from "../../Services";
import { toast } from "react-toastify";
// import AddCategory from "./AddCategory";
// eslint-disable-next-line
import AddCategory from "./addservices";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastError, ToastSuccess } from "../../Components/utils/ToastMessage";
import ReactPaginate from "react-paginate";
import swal from "sweetalert";
function Warehouse() {
    const Navigate = useNavigate();
    const [showPaginate, setShowPagiate] = useState(false);
    const [params, setparams] = useSearchParams();
    const [tableLoad, setTableLoad] = useState(false);
    const [pageCount, setpageCount] = useState(1);
    const [category, setCategory] = useState(false);
    const [city, setCity] = useState([]);
    const [editable, setEditable] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [search, setSearch] = useState(false);
    const [categoryItems, setCategoryItems] = useState([]);
    const [selectedCity, setselectedCity] = useState("");
    const [categorysearchItems, setCategorySearchItems] = useState([]);
    const [pagsize, setpagesize] = useState(20);
    const [forcepage, setforcepage] = useState();
    let [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const categoryHandler = () => {
        setCategory((prev) => !prev);
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    const getcities = () => {
        Services.getcities("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setCity(res.Cities);
                    const queryParams = new URLSearchParams(
                        window.location.search
                    );

                    // Create an object to store the query parameters
                    const queryParamsObject = {};

                    // Loop through all the query parameters and add them to the object
                    queryParams.forEach((value, key) => {
                        queryParamsObject[key] = value;
                    });
                    let city;
                    if (params.get("city")) {
                        city = params.get("city");
                        setselectedCity(city);
                    } else {
                        city = res.Cities[0].cityname;
                        setselectedCity(city);
                        setparams({
                            ...queryParamsObject,
                            city,
                        });
                    }
                    getcategories(
                        city,
                        Number(params.get("page") - 1) * pagsize
                    );
                    setforcepage(Number(params.get("page") - 1));
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    const search_API = (skip, city) => {
        if (!search) {
            setSearch(true);
        }
        console.log(searchString);
        Services.ServiceByCitySearch(
            "POST",
            JSON.stringify({
                servicename: searchString,
                city,
                limit: pagsize,
                skip,
            }),
            token
        )
            .then((res) => {
                setTableLoad(false);
                if (res.Status === 1) {
                    setCategoryItems(res.Services);
                    setCategorySearchItems(res.Services);
                    if (res.Count > 0) {
                        setShowPagiate(true);
                        setpageCount(
                            Math.ceil(Number(res?.Count) / Number(pagsize))
                        );
                    }

                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        let searchApi;
        if (searchString.length > 0) {
            setparams({ page: 1, city: selectedCity });

            searchApi = setTimeout(() => {
                setTableLoad(true);
                setShowPagiate(false);
                setforcepage(0);
                search_API(0, selectedCity);
            }, 300);
        } else if (selectedCity) {
            setTableLoad(true);
            setparams({ page: 1, city: selectedCity });
            setforcepage(0);
            setSearch(false);
            getcategories(selectedCity, 0);
        } else {
            setTableLoad(true);
            setSearch(false);
            getcities();
        }
        return () => {
            clearTimeout(searchApi);
        };
    }, [searchString]);
    // console.log(params.getAll());
    const getcategories = (ServiceByCity, skip) => {
        Services.ServiceByCity(
            "POST",
            JSON.stringify({ city: ServiceByCity, skip, limit: pagsize }),
            token
        )
            .then((res) => {
                if (res.Status === 1) {
                    setCategoryItems(res.Services);
                    setCategorySearchItems(res.Services);
                    if (res.Count > 0) {
                        setShowPagiate(true);
                        setpageCount(
                            Math.ceil(Number(res?.Count) / Number(pagsize))
                        );
                    }

                    setTableLoad(false);
                    setLoading(false);
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        if (params.get("page")) {
            setpageCount(Number(params.get("page")));
        }

        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        let timer = setTimeout(() => {
            setTableLoad(false);
            console.log("11");
        }, 150);
        return () => {
            clearTimeout(timer);
        };
    }, [categorysearchItems]);

    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        console.log("aa");
        swal("Are You sure you want to Delete?", {
            icon: "warning",
            className: dashboardclasses["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Delete",
                    value: "Delete",
                    className: dashboardclasses[".cancel-delete"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(true);
                    Services.DeleteCityWiseServices(
                        "POST",
                        JSON.stringify({ _id: id }),
                        token
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getcategories(selectedCity, 0);
                                setforcepage(0);
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const ActionFormatter = (cell, cellcontent) => {
        return (
            <div className={dashboardclasses.tablebtns}>
                <button
                    onClick={() => {
                        setEditable(cellcontent);
                        setCategory(true);
                    }}>
                    <FaRegEdit size={18} />
                </button>
                <button onClick={deleteHandler} id={cellcontent._id}>
                    <MdDelete size={18} />
                </button>
            </div>
        );
    };
    const statusFormatter = (cell) => {
        let classname =
            cell === "Active"
                ? dashboardclasses["status_active"]
                : dashboardclasses["status_inactive"];
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                <p className={classname}>{cell}</p>
            </div>
        );
    };
    const columns = [
        {
            dataField: "servicename",
            text: "SERVICE NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "categoryname",
            text: "CATEGORY NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "subcategoryname",
            text: "SUB CATEGORY NAME",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "servicecost",
            text: "SERVICE COST",
            sort: false,
            formatter: (cell) => (
                <p style={{ textAlign: "center" }}>₹ {cell}</p>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },
        {
            dataField: "discount_servicecost",
            text: "DISCOUNT SERVICE COST",
            sort: false,
            formatter: (cell) => (
                <p style={{ textAlign: "center" }}>₹ {cell}</p>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },
        {
            dataField: "vendorcharges",
            text: "VENDOR CHARGES",
            sort: false,
            formatter: (cell) => (
                <p style={{ textAlign: "center" }}>₹ {cell}</p>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, textAlign: "center" };
            },
        },

        {
            dataField: "ACTIONS",
            text: "ACTIONS",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
        {
            dataField: "status",
            text: "STATUS",
            sort: false,
            formatter: statusFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
    ];
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setforcepage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);
        setparams({ page: selectedObject.selected + 1, city: selectedCity });
        if (search) {
            search_API(selectedObject.selected * pagsize, selectedCity);
        } else {
            getcategories(selectedCity, selectedObject.selected * pagsize);
        }
        setTableLoad(true);
    };
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        setSearchString(e.target.value);
        // setTableLoad(true);
        // setparams({ page: 1 });
        // setpageCount(1);
        // const search = categoryItems.filter((item) =>
        //     item.servicename
        //         .toLowerCase()
        //         .includes(e.target.value.toLowerCase())
        // );
        // // console.log(search);
        // setCategorySearchItems(search);
    };
    const cityChangeHandler = (e) => {
        let selected = e.target.value;
        setselectedCity(selected);
        setforcepage(0);
        setTableLoad(true);
        setparams({ page: 1, city: selected });
        if (search) {
            getcategories(selected, 0);
            setSearch(false);
        } else {
            search_API(0, e.target.value);
        }
        // setShowPagiate(false);
    };
    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    return (
        <>
            {category && (
                <AddCategory
                    setmodal={setCategory}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    selectedCity={selectedCity}
                    search={search}
                    searchAPI={search_API}
                    cities={city}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                />
            )}

            <Layout Active={"Service-City"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Services</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by service name"
                                        onChange={searchHandler}
                                    />
                                    <select
                                        value={selectedCity}
                                        onChange={cityChangeHandler}>
                                        {city.map((item) => (
                                            <option value={item.cityname}>
                                                {item.cityname}
                                            </option>
                                        ))}
                                    </select>
                                    <button onClick={categoryHandler}>
                                        + Add Service
                                    </button>
                                </div>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            noDataIndication={emptyDataMessage}
                                            data={categorysearchItems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            wrapperClasses="table-responsive"
                                        />
                                    </div>
                                )}
                                {showPaginate && (
                                    <div
                                        style={{
                                            justifySelf: "right",
                                        }}>
                                        <ReactPaginate
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            onPageChange={handlePageChange}
                                            forcePage={forcepage}
                                            breakClassName={"page-item"}
                                            breakLinkClassName={"page-link"}
                                            containerClassName={"pagination"}
                                            pageClassName={"page-item"}
                                            pageLinkClassName={"page-link"}
                                            previousClassName={"page-item"}
                                            previousLinkClassName={"page-link"}
                                            nextClassName={"page-item"}
                                            nextLinkClassName={"page-link"}
                                            activeClassName={"active"}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
